import { Tag, ToggleGroup } from '@loadsmart/loadsmart-ui'

import { Icon } from 'core/ui/components/icon/Icon'

import { type ConfirmAwardedLaneAction } from '../domain/ConfirmAwardedLaneAction'
import { type Lane } from '../domain/Lane'
import {
  getAwardedConfirmationInfo,
  getAwardedLaneConfirmedValue,
  OPTION_ACCEPTED,
  OPTION_REJECTED,
} from '../presenters/rfpAwardedPresenter'

const confirmOptions = [
  {
    label: 'Accept',
    value: OPTION_ACCEPTED,
    leading: <Icon name="check" size="14" />,
  },
  {
    label: 'Reject',
    value: OPTION_REJECTED,
    leading: <Icon name="close" size="14" />,
  },
]

export type AwardConfirmationActionsProps = {
  awardedLane: Lane
  isAwardFinished?: boolean
  isConfirming?: boolean
  isDisabled?: boolean
  handleConfirmLane?: (laneId: number, action: ConfirmAwardedLaneAction) => void
}

export function AwardConfirmationActions({
  awardedLane,
  isConfirming,
  isDisabled,
  isAwardFinished,
  handleConfirmLane,
}: AwardConfirmationActionsProps) {
  if (isAwardFinished) {
    const awardConfirmationInfo = getAwardedConfirmationInfo(awardedLane)
    return <Tag variant={awardConfirmationInfo.tagVariant}>{awardConfirmationInfo.label}</Tag>
  }

  const currentValue = getAwardedLaneConfirmedValue(awardedLane)

  function handleOnChange(value: ConfirmAwardedLaneAction) {
    if (handleConfirmLane) handleConfirmLane(awardedLane.laneProposal!.id, value)
  }

  const disableConfirmation = isConfirming || isDisabled

  return (
    <ToggleGroup
      options={confirmOptions}
      value={currentValue}
      onChange={({ target: { value } }) => handleOnChange(value as ConfirmAwardedLaneAction)}
      disabled={disableConfirmation}
    />
  )
}
